import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes.js';
import PublicRoutes from './PublicRoutes.js';
import SignIn from '../components/signIn/index.js';
import SignUp from '../components/signUp/index.js';
import AdminPanel from '../components/adminPanel/index.js';
import ForgotPassword from '../components/forgotPassword/index.js';
import EmailVerify from '../components/emailVerify/index.js';
import NewUserRegister from '../components/newUserRegister/index.js';
import ChangePassword from '../components/changePassword/index.js';
import MySettings from '../components/mySettings/index.js';
import CostCalculator from '../components/costCalculator/index.js'
import CandidateSearch from '../components/adminPanel/candidateSearch/index.js';
import NotFound from '../components/notFound/index.js';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

const DirectRoutes = () => {
  return (
    <div>
      <BrowserRouter basename={'app'}>
        <Routes>
          <Route path="/signin" element={<PublicRoutes><SignIn /></PublicRoutes>} />
          <Route path="/signup" element={<PublicRoutes><SignUp /></PublicRoutes>} />
          <Route path="/forgotpassword" element={<PublicRoutes><ForgotPassword /></PublicRoutes>} />
          <Route path="/cost-calculator" element={<PublicRoutes><CostCalculator /></PublicRoutes>} />
          <Route path="/join-company-user/:id" element={<PublicRoutes><NewUserRegister /></PublicRoutes>} />

          {/* Company Internal Routes */}
          <Route path="/company/*" element={<PrivateRoutes><AdminPanel /></PrivateRoutes>} >
          </Route>
          <Route path="/email-verify" element={<PrivateRoutes><EmailVerify /></PrivateRoutes>} />
          <Route path="/changePassword" element={<PrivateRoutes><ChangePassword /></PrivateRoutes>} />
          <Route path="/my-settings/*" element={<PrivateRoutes><MySettings /></PrivateRoutes>} >
          </Route>
          <Route path="/candidate-search" element={<PrivateRoutes><CandidateSearch /></PrivateRoutes>} />

          {/* 404 error page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default DirectRoutes;